var _path, _g, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWireframe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Color",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.25 0h-20.5c-.965 0-1.75.785-1.75 1.75v2.5c0 .965.785 1.75 1.75 1.75h20.5c.965 0 1.75-.785 1.75-1.75v-2.5c0-.965-.785-1.75-1.75-1.75z",
    fill: "#03a9f4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#90a4ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.75 10.5h9.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-9.5c-.414 0-.75.336-.75.75s.336.75.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.75 13.5h9.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-9.5c-.414 0-.75.336-.75.75s.336.75.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.75 16.5h9.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-9.5c-.414 0-.75.336-.75.75s.336.75.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.75 19.5h9.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-9.5c-.414 0-.75.336-.75.75s.336.75.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.75 22.5h9.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-9.5c-.414 0-.75.336-.75.75s.336.75.75.75z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24 10.5v10.5c0 .23-.05.45-.15.65-.16.33-.43.59-.77.73-.18.08-.37.12-.58.12h-8c-.83 0-1.5-.67-1.5-1.5v-10.5c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5z",
    fill: "#90caf9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24 16.82v4.18c0 .83-.67 1.5-1.5 1.5h-7.99l6.115-8.737c.089-.128.233-.206.388-.213s.305.06.405.179z",
    fill: "#689f38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m23.85 21.65c-.16.33-.43.59-.77.73-.18.08-.37.12-.58.12h-8c-.83 0-1.5-.67-1.5-1.5v-3.21l2.79-2.79c.19-.19.45-.3.71-.3.27 0 .52.11.71.3z",
    fill: "#8bc34a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireframe);
export default __webpack_public_path__ + "static/media/wireframe.39998775098f074e348577702e2bbf90.svg";
export { ForwardRef as ReactComponent };